<template>
  <WidgetMecleeUiLandingsBusinessLanding
    :supportTexts="supportTexts"
    :supportBtnText="t('meclee-ui.landings.business.cta1')"
    :faqBisnessContent="faqList"
    :whyChooseUsBusiness="whyChooseUsBusiness"
    ref="landingEl"
  >
    <template #form>
      <LazyWidgetContentFormsForm @submitted="onFormSubmitted" />
    </template>
  </WidgetMecleeUiLandingsBusinessLanding>
</template>

<script setup>
definePageMeta({
  layout: 'public',
});

const { $seo } = useNuxtApp();
const { t } = useI18n();
const config = useRuntimeConfig();
const route = useRoute();
const localePath = useLocalePath();
useSeoMeta({
  title: $seo.getTitle('seo./business.title'),
  description: $seo.getDescription(),
})
const schemaOrg = ref([
  defineBreadcrumb({
    itemListElement: [
      defineListItem({
        item: {
          '@id': config.public.url + localePath(`/`),
          name: $seo.getTitle(`seo./.title`)
        }
      }),
      defineListItem({
        item: {
          '@id': config.public.url + route.fullPath,
          name: $seo.getTitle('seo./business.title')
        }
      }),
    ]
  }),
]);
useSchemaOrg(schemaOrg.value);

const landingEl = ref();
function onFormSubmitted() {
  landingEl.value.closeForm();
}

const { data: faqList, error } = await useAsyncData(
  'faqList',
  async () => {
    return new Promise(async (resolve, reject) => {
      try {
        const {faqList, fetchFaqList} = useContentFaq();
        await fetchFaqList('landing.business');

        faqList.value.forEach((item) => {
          schemaOrg.value.push(
            defineQuestion({
              name: item.question,
              acceptedAnswer: {
                text: item.answer.replace(/(<([^>]+)>)/gi, ""),
              }
            })
          );
        })
        resolve(faqList.value);
      } catch (error) {
        reject(error);
      }
    });
  }
)

const supportTexts = [
  'meclee-ui.landings.business.advantages.0',
  'meclee-ui.landings.business.advantages.1',
  'meclee-ui.landings.business.advantages.2',
]

const whyChooseUsBusiness = [
  {
    key: 1,
    contentTitle: 'meclee-ui.landings.business.why-choose-us.reasons.0.title',
    contentText: {
      text: null,
      list: [
        `meclee-ui.landings.business.why-choose-us.reasons.0.content.0`,
        `meclee-ui.landings.business.why-choose-us.reasons.0.content.1`,
        `meclee-ui.landings.business.why-choose-us.reasons.0.content.2`,
      ],
    },
  },
  {
    key: 2,
    contentTitle: 'meclee-ui.landings.business.why-choose-us.reasons.1.title',
    contentText: `meclee-ui.landings.business.why-choose-us.reasons.1.content`
  },
  {
    key: 3,
    contentTitle: 'meclee-ui.landings.business.why-choose-us.reasons.2.title',
    contentText: {
      text: null,
      list: [
        `meclee-ui.landings.business.why-choose-us.reasons.2.content.0`,
        `meclee-ui.landings.business.why-choose-us.reasons.2.content.1`,
      ],
    },
  },
];
</script>
